/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EventsIcon extends BaseIcon {
  getChildren = () => [
    <path fill={this.getColor()} d="M13,6.05v6a6,6,0,0,1,2.24.86l4.29-4.29A12,12,0,0,0,13,6.05Zm8,4L16.72,14.3A6,6,0,0,1,18,18h6A11.94,11.94,0,0,0,21,10.05ZM0,18H6a6,6,0,0,1,5-5.91v-6A12,12,0,0,0,0,18Z"/>
  ]
  getViewBox = () => '0 0 24 24'
}
